module.exports = __webpack_public_path__ + "static/media/intelligent-investor.4e07fe6f.jpg";